var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "md-button",
            {
              staticClass:
                "md-simple md-just-icon md-round modal-default-button",
              on: { click: _vm.closeFilterModal },
            },
            [_c("md-icon", [_vm._v("clear")])],
            1
          ),
        ],
        1
      ),
      _c("template", { slot: "body" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "filter-field-container" },
            [
              _c(
                "md-field",
                [
                  _c("label", [_vm._v("Industry")]),
                  _c(
                    "md-select",
                    {
                      staticClass: "select-modal",
                      attrs: { name: "company-industry", id: "industry" },
                      on: { input: _vm.handelIndustryChange },
                      model: {
                        value: _vm.selectedIndustry,
                        callback: function ($$v) {
                          _vm.selectedIndustry = $$v
                        },
                        expression: "selectedIndustry",
                      },
                    },
                    _vm._l(_vm.companyIndustry, function (value, index) {
                      return _c(
                        "md-option",
                        { key: index, attrs: { value: value } },
                        [_vm._v(_vm._s(value))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "md-field",
                [
                  _c("label", [_vm._v("Sector")]),
                  _c(
                    "md-select",
                    {
                      attrs: { name: "company-sector", id: "sector" },
                      on: { input: _vm.handelSectorChange },
                      model: {
                        value: _vm.selectedSector,
                        callback: function ($$v) {
                          _vm.selectedSector = $$v
                        },
                        expression: "selectedSector",
                      },
                    },
                    _vm._l(_vm.companySector, function (value, index) {
                      return _c(
                        "md-option",
                        { key: index, attrs: { value: value } },
                        [_vm._v(_vm._s(value))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "filter-button-row" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-success",
                  on: { click: _vm.handleClearFilters },
                },
                [_vm._v("Clear Filters")]
              ),
              _c(
                "md-button",
                { staticClass: "md-danger", on: { click: _vm.handleClose } },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }